module.exports = __webpack_public_path__ + "static/media/profile-pic-placeholder.809a3c5a.png";